import React from 'react'
import clsx from 'clsx'
import { Rating } from 'react-simple-star-rating'
import { ReviewCardProps } from '@/components/molecules/ReviewCard/types'

export function ReviewCard({ date, rating, content, author, position }: ReviewCardProps) {
  const dateParsed = new Date(date).toLocaleDateString('en-GB').replaceAll('.', '/')

  return (
    <div
      className={clsx(
        'border-1 border-primary-300 rounded-[30px] max-xs:h-[450px] h-[420px] tablet:h-[450px] tablet-lg:h-[400px] desktop:h-[400px] max-h-[485px] desktop-lg:max-h-[385px] w-[calc(100vw-40px)] tablet:w-[calc(50vw-42px)]  laptop:w-[400px] tablet:p-40 p-32 text-start bg-[rgba(249,248,253,0.75)]'
      )}
    >
      <div className="w-full flex justify-between items-baseline">
        <span className="text-bodyS text-text-dark-900 mt-4">{dateParsed}</span>
        <Rating
          initialValue={rating}
          iconsCount={5}
          SVGclassName="inline-block mb-4"
          readonly
          size={18}
          allowFraction
          SVGstorkeWidth={1}
          SVGstrokeColor="#FE8620"
          fillColor="#FE8620"
          emptyColor="rgba(255,255,255,0)"
          fillClassName="hidden"
        />
      </div>
      <p className="review-card text-bodyL text-text-brand-darker my-16 font-poppins tablet:mb-25 tablet:mt-20 laptop:px-0 max-w-44 mx-auto font-bold ">
        &quot;{content}&quot;
      </p>
      <p className="block font-poppins text-bodyS font-bold text-text-dark-900 mb-4">{author}</p>
      <p className="text-bodyS text-text-dark-900">{position}</p>
    </div>
  )
}
